// Itens dos checklists Sand Art — espelho de sandart.py no backend.
//
// Fica estatico aqui de proposito: estas secoes sao consumidas por telas que
// o Dashboard captura com html2canvas para o compartilhamento diario, e uma
// busca assincrona no meio da captura sairia com a lista vazia na imagem.
// Se mexer em algum `key`, mexa tambem em sandart.py e no SQL.

export const SANDART_OPENING_SECTIONS = [
  {
    key: 'abertura', title: 'Abertura', emoji: '🌅',
    items: [
      { key: 'sa_retirar_dobrar_capa',    label: 'Retirar e dobrar a capa com zelo e cuidado' },
      { key: 'sa_guardar_capa_kiosk',     label: 'Guardar a capa dentro do kiosk' },
      { key: 'sa_verificar_espaco_limpo', label: 'Verificar se o espaço está limpo e organizado antes de iniciar' },
      { key: 'sa_reportar_problemas',     label: 'Reportar se tiver algo sujo, quebrado ou estragado nos canais corretos' },
    ],
  },
  {
    key: 'materiais', title: 'Conferência de Materiais', emoji: '🪣',
    items: [
      { key: 'sa_agua_sal_preparada', label: 'Conferir se a água com sal já está preparada',
        hint: 'Se não estiver, pegue o balde, vá até o banheiro e encha com água até a marca indicada' },
      { key: 'sa_areia_condicoes',    label: 'Verificar se a areia está em boas condições',
        hint: 'Se estiver muito seca, adicionar um pouco de água e misturar até a consistência desejada' },
      { key: 'sa_conferir_materiais', label: 'Conferir todos os materiais necessários para as atividades' },
      { key: 'sa_reportar_falta',     label: 'Reportar imediatamente caso esteja faltando algum item' },
    ],
  },
  {
    key: 'exposicao', title: 'Organização e Exposição', emoji: '🎨',
    items: [
      { key: 'sa_expor_displays',         label: 'Expor todos os displays de amostra',
        hint: 'Bem posicionados para chamar atenção dos clientes' },
      { key: 'sa_placa_precos',           label: 'Placa com preços' },
      { key: 'sa_panfletos',              label: 'Panfletos' },
      { key: 'sa_placa_itens',            label: 'Placa indicando os itens' },
      { key: 'sa_areia_limpa_organizada', label: 'Areia limpa e organizada' },
      { key: 'sa_materiais_apoio',        label: 'Materiais de apoio organizados' },
      { key: 'sa_caderno_pronto',         label: 'Caderno pronto para anotar as vendas',
        hint: 'Nome, qual o molde, cores de glitter e informações do cliente' },
    ],
  },
];

export const SANDART_CLOSING_SECTIONS = [
  {
    key: 'limpeza', title: 'Limpeza Geral', emoji: '🧽',
    items: [
      { key: 'sa_limpar_chao',            label: 'Limpar o chão', hint: 'Sem nenhum vestígio de plaster ou glitter' },
      { key: 'sa_limpar_kiosk_interno',   label: 'Limpar a parte interna do kiosk com a vassourinha', hint: 'Remover poeira e areia' },
      { key: 'sa_limpar_moldes',          label: 'Limpar os moldes antes de guardar na caixa' },
      { key: 'sa_higienizar_cestinha',    label: 'Retirar os materiais da cestinha e higienizar com wipes' },
      { key: 'sa_materiais_limpos_secos', label: 'Guardar os materiais somente quando estiverem limpos e secos' },
      { key: 'sa_lavar_medidores',        label: 'Lavar os medidores' },
      { key: 'sa_lavar_utensilios',       label: 'Lavar colheres e outros utensílios', hint: 'Com esponja, água e sabão' },
      { key: 'sa_secar_antes_guardar',    label: 'Secar completamente antes de guardar' },
      { key: 'sa_esvaziar_lixo',          label: 'Esvaziar o cesto de lixo' },
    ],
  },
  {
    key: 'organizacao', title: 'Organização dos Materiais', emoji: '📦',
    items: [
      { key: 'sa_guardar_baldes',        label: 'Guardar os baldes de forma organizada' },
      { key: 'sa_mistura_agua_sal',      label: 'Deixar a mistura de água com sal preparada para o dia seguinte' },
      { key: 'sa_guardar_displays',      label: 'Guardar os displays de amostra sobre a areia', hint: 'Com o plástico entre eles' },
      { key: 'sa_cobrir_displays',       label: 'Cobrir os displays com a toalha', hint: 'Evita danos e quebras' },
      { key: 'sa_organizar_gaveta',      label: 'Organizar a gaveta' },
      { key: 'sa_tudo_no_lugar',         label: 'Colocar tudo no devido lugar' },
      { key: 'sa_colher_no_plaster',     label: 'Deixar apenas a colher dentro do balde de plaster' },
      { key: 'sa_sem_pote_no_plaster',   label: 'Não deixar nenhum pote dentro do plaster ou da água' },
      { key: 'sa_toalha_glitter_sacola', label: 'Colocar a toalha de glitter dentro de uma sacola' },
    ],
  },
  {
    key: 'seguranca', title: 'Segurança', emoji: '🔒',
    items: [
      { key: 'sa_fechar_sombrinha',     label: 'Fechar a sombrinha' },
      { key: 'sa_trancar_cadeados',     label: 'Trancar todas as portas com os cadeados' },
      { key: 'sa_cobrir_toalha_sacola', label: 'Cobrir com a toalha / sacola plástica' },
      { key: 'sa_cobrir_kiosk_capa',    label: 'Cobrir o kiosk com a capa e prender bem' },
      { key: 'sa_colocar_sign',         label: 'Colocar o sign por cima do kiosk' },
    ],
  },
  {
    key: 'material', title: 'Materiais', emoji: '🧰',
    items: [
      { key: 'sa_material_suficiente', label: 'Verificar se há material suficiente para os próximos dias',
        hint: 'Se estiver faltando, reportar na aba Material' },
      { key: 'sa_reportar_reposicao',  label: 'Reportar qualquer necessidade de reposição antes de encerrar o turno' },
    ],
  },
  {
    key: 'fotos', title: 'Fotos', emoji: '📸',
    items: [
      { key: 'sa_foto_chao',          label: 'Foto do chão limpo' },
      { key: 'sa_foto_potes',         label: 'Foto dos potes lavados', hint: 'Separados e não empilhados' },
      { key: 'sa_foto_areia',         label: 'Foto da areia limpa e organizada' },
      { key: 'sa_foto_displays',      label: 'Foto dos displays organizados em cima da sacola plástica' },
      { key: 'sa_foto_moldes',        label: 'Foto dos moldes limpos na caixa' },
      { key: 'sa_foto_gaveta',        label: 'Foto da gaveta organizada' },
      { key: 'sa_foto_tablet',        label: 'Foto do tablet carregado' },
      { key: 'sa_foto_kiosk_interno', label: 'Foto da organização dentro do kiosk' },
      { key: 'sa_foto_kiosk_fechado', label: 'Foto do kiosk fechado' },
    ],
  },
  {
    key: 'conferencia', title: 'Conferência Final', emoji: '✅',
    items: [
      { key: 'sa_conferencia_final', label: 'Conferi que todos os itens acima foram realmente concluídos',
        hint: 'Evita problemas no dia seguinte e mantém o padrão do kiosk' },
    ],
  },
];

export const SANDART_OPENING_KEYS = SANDART_OPENING_SECTIONS.flatMap((s) => s.items.map((i) => i.key));
export const SANDART_CLOSING_KEYS = SANDART_CLOSING_SECTIONS.flatMap((s) => s.items.map((i) => i.key));

// Um registro é Sand Art se o backend disse que é, ou se traz alguma chave sa_*
// (as rotas antigas de leitura que ainda não devolvem o flag).
export const isSandartRecord = (data) =>
  !!data && (data.is_sandart === true || Object.keys(data).some((k) => k.startsWith('sa_')));
